<template>
	<div>
		<button class="btn dm-decline-book" 
			:class="{'is-declined' : isDeclined }"
			@click="toggleFavourite()"
            data-bs-toggle="tooltip" :title="buttonText">
			<svg-icon icon="ban" />
		</button>
	</div>
</template>

<script>

export default {
	props: ['declined', 'book_id'], // Used just to pass the data from Blade
    data() {
        return {
			isDeclined: false
        };
    },
	computed: {
		buttonText() {
			return (this.isDeclined) ? 'Remove from Declined' : 'Add to Declined';
		}
	},
    methods: {
        toggleFavourite() {
			var self = this;

			axios.post('/api/editor/declined/' + this.book_id)
				.then(function (response) {
					self.isDeclined = response.data.is_declined;
				})
				.catch(function (error) {
					console.log(error);            
				});
		}
    },
    mounted() {
		this.isDeclined = (this.declined) ? true : false;
    }
}
</script>
